import { render, staticRenderFns } from "./Historical.vue?vue&type=template&id=1b4aef5c&scoped=true&"
import script from "./Historical.vue?vue&type=script&lang=js&"
export * from "./Historical.vue?vue&type=script&lang=js&"
import style0 from "./Historical.vue?vue&type=style&index=0&id=1b4aef5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4aef5c",
  null
  
)

export default component.exports